import env from '@eneco/common/env';

const site = env('SITECORE_API_SITE');
export const getAccountSwitchHref = (accountid: string) => {
  if (typeof window === 'undefined') return '';
  const switchAccountURL = new URL('/identity/switchaccount', window.location.origin);
  switchAccountURL.searchParams.append('accountid', accountid);
  switchAccountURL.searchParams.append('url', window.location.pathname);
  switchAccountURL.searchParams.append('sc_site', site);
  return switchAccountURL.href;
};
